jQuery(() => {
    $("body").on("click", ".recover-btn", function () {
        $(".recover_password").validate();
        $("#RecoverEmail").rules("add", {
            required: true,
            email: true,
            messages: {
                required: "Please enter a valid email address (Ex. johndoe@domain.com)"
            }
        });

        if ($(".recover_password").valid()) {
            $(".recover_password").submit();
        }
    });
});

const login_recover = {
    decoy_form: $('#recover-form'),
    form: $('#recover-form-submission'),
    error: $('#popup-login-form').find('.errors'),
    loading: $('#popup-login-form').find('.spinner-container'),
    hideLoadingState: () => {
        login_recover.loading.hide();
    },
    showLoadingState: () => {
        login_recover.loading.show();
    },
    serializeForm: (form) => {
        const formArray = form.serializeArray();
        var returnArray = {};
        for (var i = 0; i < formArray.length; i++) {
            returnArray[formArray[i]['name']] = formArray[i]['value'];
        }
        return returnArray;
    },
    handleLoginCheck: () => {
        const form_data = login_recover.serializeForm(login_recover.decoy_form)

        login_recover.form.find('#RecoverEmail').val(form_data["customer[email]"]);
        login_recover.form.trigger('submit');

        if (document.body.getAttribute('data-customer-invitation')) {
            document.removeEventListener('login:checked', login_recover.handleLoginCheck, false);
        }
    },
    handleRecoverValidation: (event) => {
        const event_detail = event.detail;
        login_recover.showLoadingState();

        if (event_detail.status) {
            if (document.body.getAttribute('data-customer-invitation')) {
                document.dispatchEvent(new CustomEvent('login:check', {
                    detail: {
                        form: "#recover-form",
                    }
                }))

                document.addEventListener('login:checked', login_recover.handleLoginCheck);
            } else {
                login_recover.handleLoginCheck();
            }
        }

        document.removeEventListener("form:validation", login_recover.handleRecoverValidation, false);
    },
    handleLoginSubmit: (event) => {
        event.preventDefault();
        event.stopPropagation();

        document.addEventListener('form:validation', login_recover.handleRecoverValidation);
    },
    appendFormInformation: () => {
        const form_messages = login_recover.form.find('.recover-form-validation');

        if (form_messages)
            login_recover.decoy_form.prepend(form_messages);
    },
    init: () => {
        login_recover.decoy_form.on('submit', login_recover.handleLoginSubmit);
        login_recover.appendFormInformation();
    }
}

login_recover.init();
